const API_ENDPOINTS = {
  auth: {
    REGISTER: "/auth/register",
  },
};

export default API_ENDPOINTS;
